import React from 'react';
import Icon from '../Icons/Icon';
import { Text } from '@/Components/Primitives';

const OfflineUnavailable = () => {
    return (
        <div className="flex flex-col items-center justify-center gap-4 my-8 relative w-full text-center">
            <Icon
                icon="WifiSlash"
                size="6x"
                className="fill-gray-500"
                inline
            />

            <span className="mx-auto block text-lg font-semibold max-w-[75%]">
                Offline
            </span>

            <span className="mx-auto block text-sm max-w-[75%] text-pretty">
                <Text>
                    We couldn't load this content because you're currently offline.<br />
                    Please check your internet connection and try again.
                </Text>
            </span>
        </div>
    );
};

export default OfflineUnavailable;
